// extracted by mini-css-extract-plugin
export default {"loginbutton":"GoogleLogin_loginbutton__ynM+P","animate-rotate":"GoogleLogin_animate-rotate__diE6z"};